import { I18nHealthCheck } from "./healthCheck.i18n";
import { HEALTH_CHECK_ITEM_DATATYPE, HEALTH_CHECK_TYPE } from "./healthCheck.types";

const i18n = I18nHealthCheck();

export enum HealthCheckDataSourceUID {
    HEALTHCHECKDATA_TYPES = "HEALTHCHECKDATA_TYPES",
    HEALTHCHECK_TYPES = "HEALTHCHECK_TYPES"
}

export const hcdTypes: { id: HEALTH_CHECK_ITEM_DATATYPE, val: string }[] = [
    { id: HEALTH_CHECK_ITEM_DATATYPE.BOOLEAN, val: i18n.boolean },
    { id: HEALTH_CHECK_ITEM_DATATYPE.TEXT, val: i18n.text },
    { id: HEALTH_CHECK_ITEM_DATATYPE.DATE, val: i18n.date }
];

export const hctypes: { id: HEALTH_CHECK_TYPE, val: string }[] = [
    { id: HEALTH_CHECK_TYPE.INITIAL, val: i18n.initial },
    { id: HEALTH_CHECK_TYPE.CHECK_UP, val: i18n.checkUp },
    { id: HEALTH_CHECK_TYPE.FINAL, val: i18n.final }

];